import '../App.css';
import { useUser } from '../context/UserContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import WebApp from '@twa-dev/sdk';
import { UserCircleIcon } from '@heroicons/react/24/outline';

const Home = () => {
    const { user, loading: userLoading, isTelegramApp } = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if (isTelegramApp) {
          WebApp.ready();
          WebApp.expand();
        }
      
        if (!userLoading && !user) {
          navigate('/auth');
        }
      
        if (user && user.role === 'user' && window.location.pathname !== '/user') {
          navigate('/user');
        }
      
        if (user && user.role === 'admin' && window.location.pathname !== '/admin') {
          navigate('/admin');
        }
        if (user && user.role === 'customer' && window.location.pathname !== '/supplier') {
            navigate('/supplier');
          }
      }, [userLoading, user, isTelegramApp, navigate]);
      

    const isLoading = userLoading;

    if (isLoading) {
        return (
            <div className="flex justify-center items-center text-white p-8">
                Загрузка...
            </div>
        );
    }

    return (
        <div className="text-gray-200 p-4 md:p-8">
            <div className="w-full max-w-6xl mx-auto p-6 md:p-8 space-y-8 bg-gray-800 bg-opacity-80 backdrop-filter backdrop-blur-sm rounded-xl shadow-2xl">
                {user && user.role === 'admin' && (
                    <div className="bg-gradient-to-r from-blue-800 to-indigo-800 p-6 rounded-lg shadow-lg flex items-start gap-4">
                        <UserCircleIcon className="h-8 w-8 text-blue-300 flex-shrink-0 mt-1" />
                        <div>
                            <h3 className="text-xl font-semibold mb-2 text-white">Администраторская панель</h3>
                            <p className="text-blue-100">Управление пользователями и настройками.</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
    
};

export default Home;